/**
 * @export
 * @class SiteNav
 */
import { get, getAll } from '../../helpers/utilities';

import { MainMenu } from './menu';

export class SiteNav {
    private isOpen = false;
    private container = get('#js-site-nav') as Element;


    /**
     * Initialises a new instance of SiteNav
     */
    constructor() {
        if(!this.container) return;
        new MainMenu(this.container);
        this.bindEvents();
    }


    /**
     * Bind the events for this component.
     * 
     * @private
     * @return void
     */
    private bindEvents(): void {

        const toggleBtns = getAll('.js-site-nav__toggle');
        if(toggleBtns) {
            toggleBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.toggle();
                });
            });
        }
    }


    /**
     * Toggles the site nav visiblity
     * 
     * @private
     * @return void
     */
    private toggle(): void {
        if(this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }


    /**
     * Opens the site nav
     * 
     * @private
     * @return void
     */
    private open(): void {
        this.isOpen = true;
        this.container.classList.add('c-site-nav--is-open');
    }


    /**
     * Closes the site nav
     * 
     * @private
     * @return void
     */
    private close(): void {
        this.isOpen = false;
        this.container.classList.remove('c-site-nav--is-open');
    }
}
